import { VStack } from "@chakra-ui/react"
import React from "react"
import { Employee } from "types/Employee"
import { RoutingInfo } from "types/RoutingInfo"
import { AdditionalInfoQuestionKey } from "utils/RoutingInfoQuestionKey"
import AboutYouDetail from "./AboutYouDetail"
import { AnythingElseJourneyAnswer } from "./AnythingElseAnswer"
import JourneyInfoDetail from "./JourneyInfoDetail"
import MedicalInfoDetail from "./MedicalInfoDetail"
import PastRoutingAnswers from "./PastRoutingAnswers"

type RoutingInfoDetailProps = {
  currentRoutingInfo: RoutingInfo
  pastRoutingInfo: RoutingInfo[]
  employee: Employee
  showAboutYou: boolean
  showPastRoutingAnswers?: boolean
}

// Get the previous routing info for the current routing info by sorting routingInfoIds in descending order
const getPreviousRoutingInfo = (currentRoutingInfo: RoutingInfo, pastRoutingInfo: RoutingInfo[]) => {
  return pastRoutingInfo && currentRoutingInfo
    ? pastRoutingInfo
        .filter((ri) => ri.routingInfoId < currentRoutingInfo.routingInfoId)
        .sort((a, b) => b.routingInfoId - a.routingInfoId)[0] || null
    : null
}

export const RoutingInfoDetail = ({
  currentRoutingInfo,
  pastRoutingInfo,
  employee,
  showAboutYou,
  showPastRoutingAnswers = true
}: RoutingInfoDetailProps) => {
  const partner = employee.partner
  const shouldShowPastRoutingAnswers = pastRoutingInfo?.length && showPastRoutingAnswers
  const previousRoutingInfo = getPreviousRoutingInfo(currentRoutingInfo, pastRoutingInfo)

  return (
    <>
      <VStack spacing={"50px"} align={"start"} shouldWrapChildren={true}>
        {showAboutYou && <AboutYouDetail {...{ routingInfo: currentRoutingInfo, partner }} />}
        {currentRoutingInfo && (
          <JourneyInfoDetail routingInfo={currentRoutingInfo} previousRoutingInfo={previousRoutingInfo} />
        )}
        <MedicalInfoDetail allMedicalInfo={currentRoutingInfo?.allMedicalInfo} />
        <AnythingElseJourneyAnswer
          subHeader={"Additional information from routing"}
          questionKey={AdditionalInfoQuestionKey.MemberJourneyAdditionalInfo}
          skipFields={currentRoutingInfo?.skipFields}
          answer={currentRoutingInfo?.memberJourneyAdditionalInfo}
          additionalTopicsShared={currentRoutingInfo?.additionalTopicsShared}
        />
        {shouldShowPastRoutingAnswers && <PastRoutingAnswers pastRoutingInfo={pastRoutingInfo} />}
      </VStack>
    </>
  )
}
